
import React from 'react';
import { RefreshCcw, UserPlus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import EmployeesTable from '@/components/admin/EmployeesTable';

interface AdminEmployeesTabProps {
  employees: any[];
  onRemoveEmployee: (id: string) => void;
  onToggleActive?: (id: string, isActive: boolean) => void;
  isProcessing: boolean;
  onRefresh: () => void;
  onAddEmployee: () => void;
  filterStatus?: string;
  onFilterChange?: (status: string) => void;
}

const AdminEmployeesTab: React.FC<AdminEmployeesTabProps> = ({
  employees,
  onRemoveEmployee,
  onToggleActive,
  isProcessing,
  onRefresh,
  onAddEmployee,
  filterStatus = 'all',
  onFilterChange
}) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-semibold">Employees</h2>
        <div className="flex gap-2">
          {onFilterChange && (
            <Select value={filterStatus} onValueChange={onFilterChange}>
              <SelectTrigger className="w-[150px]">
                <SelectValue placeholder="Filter status" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All Employees</SelectItem>
                <SelectItem value="active">Active Only</SelectItem>
                <SelectItem value="inactive">Inactive Only</SelectItem>
              </SelectContent>
            </Select>
          )}
          <Button variant="outline" size="sm" onClick={onRefresh}>
            <RefreshCcw className="h-4 w-4 mr-1" />
            Refresh
          </Button>
          <Button variant="default" size="sm" onClick={onAddEmployee}>
            <UserPlus className="h-4 w-4 mr-1" />
            Add Employee
          </Button>
        </div>
      </div>
      
      <EmployeesTable 
        employees={employees}
        onRemoveEmployee={onRemoveEmployee}
        onToggleActive={onToggleActive}
        isProcessing={isProcessing}
      />
    </div>
  );
};

export default AdminEmployeesTab;
